<template>
  <div>
    <v-sparkline
      :value="value"
      :gradient="gradients[gradient_index]"
      :smooth="radius || smooth"
      :padding="padding"
      :line-width="width"
      :stroke-linecap="lineCap"
      :gradient-direction="gradientDirection"
      :fill="fill"
      :type="type"
      :auto-line-width="autoLineWidth"
      auto-draw
      :labels="labels"
      :label-size="label_size"
      :show-labels="false"
      :height="height"
    ></v-sparkline>
  </div>
</template>

<script>
export default {
    name: "SparklineGraph",
    props: {
        value:{
            type: Array,
            default: () => {
                return [];
            }
        },
        labels:{
            type: Array,
            default: () => {
                return [];
            }
        },
        gradients:{
            type: Array,
            default: () => {
                return [
                    ['#222'],
                    ['#42b3f4'],
                    ['red', 'orange', 'yellow'],
                    ['purple', 'violet'],
                    ['#00c6ff', '#F0F', '#FF0'],
                    ['#f72047', '#ffd200', '#1feaea'],
                ];
            }
        },
        label_size: {
            type: Number,
            default: 3
        },
        gradient_index: {
            type: Number,
            default: 5
        },
        gradientDirection: {
            type: String,
            default: 'top'
        },
        radius:{
            type: [Number,Boolean],
            default: 5
        },
        smooth:{
            type: Boolean,
            default: false
        },
        padding:{
            type: Number,
            default: 8
        },
        width:{
            type: Number,
            default: 2
        },
        lineCap:{
            type: String,
            default: 'round'
        },
        fill:{
            type: Boolean,
            default: false
        },
        type:{
            type: String,
            default: 'trend'
        },
        autoLineWidth: {
            type: Boolean,
            default: false
        },
        height:{
            type: Number,
            default: 100
        },
    }
}
</script>